<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.warehousemanagement') }} > {{ $t('sidebar.all') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <base-table :hidePagination="true">
        <template #thead>
          <thead>
            <tr>
              <th>{{ $t('apps.inventory.message.warehousename') }}</th>
              <th class="text-center">{{ $t('apps.inventory.message.warehousprimary') }}</th>
              <th>{{ $t('apps.inventory.message.assignskus') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="data.length === 0"
                colspan="3"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in data"
              :key="index">
              <td :data-order="item.gt_id">
                <router-link-custom
                  :to="{name: 'WarehouseEdit', query: {
                    id: item.warehouse_id,
                    name: item.warehouse_name,
                  }}"
                  :text="item.warehouse_name"
                  :to_appid="3"
                  :current_appid="3"
                />
              </td>
              <td class="text-center">
                <i
                  v-if="item.primary"
                  class="fas fa-key text-primary"/>
              </td>
              <td>
                {{ item.assign_skus && item.assign_skus.length }}
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import tablePaginateMixin from '@/mixins/tablePaginate'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [tablePaginateMixin, userPermissionMixin],

  data () {
    return {
      loading: true,
    }
  },

  computed: {
    ...mapGetters({
      data: 'getWarehouses',
      sidebar: 'getSidebar',
    }),
  },

  watch: {
    data: function (newVal, oldVal) {
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.data))
      sidebarModule.active({
        sidebarAtIdx: 8,
        submenuAtIdx: 0,
      })
    },
  },

  async created () {
    this.fetchData()
  },

  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 9,
      },
    })
    // set sidebar stockcontrols ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.data))
    sidebarModule.active({
      sidebarAtIdx: 8,
      submenuAtIdx: 0,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, ['clearGoodstransfers'])
  },

  methods: {
    async fetchData () {
      this.loading = true
      await this.$store.dispatch('getWarehouses')
      this.loading = false
      this.showFinish(this.$Progress)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/inventory/warehouse/List.vue